// removed by extract-text-webpack-plugin
module.exports = {"FontFamilyAxiformaSemiBold":"AxiformaSemiBold,Helvetica,sans-serif","calendarSpan":"Ga27d70","calendarIcon":"Gab3a89"};